/* globals GlobalE, jQuery */
'use strict';

(function () {
    /**
     * Creates and shows a custom country switcher modal with USA and Canada options
     */
    function showCustomCountrySwitcher() {
        // Remove any existing custom modal
        var existingModal = document.getElementById('customCountrySwitcherModal');
        if (existingModal) {
            existingModal.remove();
        }

        // Create custom modal HTML
        var modalHTML = '<div class="globale_popup_wrapper" id="customCountrySwitcherModal">' +
            '<div class="gle_desktop" id="globale_csc_popup" tabindex="0">' +
            '<div class="gePopupsContainer ltr en-GB">' +
            '<div class="CustomSwitcherPopup">' +
            '<div class="glDefaultPopupContainer">' +
            '<span class="glClose" data-action="Close" onclick="closeCustomCountrySwitcher();"></span>' +
            '<div class="glPopupContent">' +
            '<div class="gleheader">' +
            '<div class="glLogo"></div>' +
            '</div>' +
            '<div class="texts">' +
            '<h1 class="glTitle">Choose your shipping destination</h1>' +
            '<h3 class="glSubTitle">Select your country to continue shopping</h3>' +
            '<div class="glMainContent">' +
            '<div class="dropDownRow">' +
            '<div class="caption">Change your shipping country</div>' +
            '<div class="dropdown">' +
            '<select aria-label="Change your shipping country" id="custom_selectedCountry" tabindex="0">' +
            '<option value="US" data-currency="1">United States</option>' +
            '<option value="CA" data-currency="26" selected>Canada</option>' +
            '</select>' +
            '</div>' +
            '</div>' +
            '<div class="dropDownRow">' +
            '<div class="caption">Currency</div>' +
            '<div class="dropdown">' +
            '<select aria-label="Currency" id="custom_selectedCurrency" tabindex="0">' +
            '<option value="USD" data-currencyid="1">US Dollar</option>' +
            '<option value="CAD" data-currencyid="26" selected>Canadian Dollar</option>' +
            '</select>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '<div class="glControls">' +
            '<input class="glDefaultBtn" type="button" value="Apply" onclick="applyCustomCountrySelection();" tabindex="0">' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>';

        // Add modal to body
        document.body.insertAdjacentHTML('beforeend', modalHTML);

        // Handle country change to update currency
        var countrySelect = document.getElementById('custom_selectedCountry');
        var currencySelect = document.getElementById('custom_selectedCurrency');

        if (countrySelect && currencySelect) {
            countrySelect.addEventListener('change', function () {
                var selectedCountry = this.value;
                if (selectedCountry === 'US') {
                    currencySelect.value = 'USD';
                } else if (selectedCountry === 'CA') {
                    currencySelect.value = 'CAD';
                }
            });
        }
    }

    /**
     * Closes the custom country switcher modal
     */
    function closeCustomCountrySwitcher() {
        var modal = document.getElementById('customCountrySwitcherModal');
        if (modal) {
            modal.remove();
        }
    }

    /**
     * Redirects to a site URL (if configured) or reloads the current page.
     *
     * @param {string} country - ISO country code (e.g., "US", "CA").
     * @param {string} currency - ISO currency code (e.g., "USD", "CAD").
     */
    function redirectOrReload(country, currency) {
        if (window.scriptLoaderData && window.scriptLoaderData.performFrontendSiteUrlRedirect) {
            jQuery.ajax(window.scriptLoaderData.getSiteRedirectUrl, {
                dataType: 'json',
                data: { countryCode: country, currencyCode: currency },
                success: function (resp) {
                    if (resp && resp.success && resp.redirectUrl) {
                        window.location.href = resp.redirectUrl;
                    } else {
                        window.location.reload();
                    }
                },
                error: function () {
                    window.location.reload();
                }
            });
        } else {
            window.location.reload();
        }
    }

    /**
     * Applies the selected country/currency to Global-e customer context and triggers a reload/redirect.
     *
     * @param {string} country - ISO country code (e.g., "US", "CA").
     * @param {string} currency - ISO currency code (e.g., "USD", "CAD").
     */
    function applyCountry(country, currency) {
        var curCountry = window.scriptLoaderData && window.scriptLoaderData.country;
        var curCurrency = window.scriptLoaderData && window.scriptLoaderData.currency;

        if (curCountry && curCurrency && curCountry === country && curCurrency === currency) {
            return;
        }

        if (
            typeof window.GlobalE !== 'undefined'
            && window.GlobalE
            && typeof window.GlobalE.UpdateCustomerInfo === 'function'
        ) {
            // eslint-disable-next-line new-cap
            window.GlobalE.UpdateCustomerInfo(country, currency, false);
        }

        redirectOrReload(country, currency);
    }

    /**
     * Applies the custom country selection and redirects/reloads
     */
    function applyCustomCountrySelection() {
        var countrySelect = document.getElementById('custom_selectedCountry');
        var currencySelect = document.getElementById('custom_selectedCurrency');

        if (countrySelect && currencySelect) {
            var country = countrySelect.value;
            var currency = currencySelect.value;

            // Close modal first
            closeCustomCountrySwitcher();

            // Apply country and currency change
            applyCountry(country, currency);
        }
    }

    // Make functions globally accessible for onclick handlers
    window.showCustomCountrySwitcher = showCustomCountrySwitcher;
    window.closeCustomCountrySwitcher = closeCustomCountrySwitcher;
    window.applyCustomCountrySelection = applyCustomCountrySelection;

    // Intercept .changeShipping clicks with capturing phase
    document.addEventListener('click', function (e) {
        var changeShippingEl = e.target.closest('.changeShipping');
        if (changeShippingEl) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            showCustomCountrySwitcher();
            return false;
        }

        var el = e.target.closest('.js-b2b-country');
        if (!el) {
            return true;
        }

        e.preventDefault();
        applyCountry(el.getAttribute('data-country'), el.getAttribute('data-currency'));
        return false;
    }, true); // Use capturing phase

    // Also monitor for dynamically added elements
    var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            if (mutation.addedNodes) {
                for (var i = 0; i < mutation.addedNodes.length; i++) {
                    var node = mutation.addedNodes[i];
                    if (node.nodeType === 1) { // Element node
                        // Check if this is a .changeShipping element
                        if (node.classList && node.classList.contains('changeShipping')) {
                            node.addEventListener('click', function (e) {
                                e.preventDefault();
                                e.stopPropagation();
                                e.stopImmediatePropagation();
                                showCustomCountrySwitcher();
                                return false;
                            }, true);
                        }
                        // Check child elements
                        var changeShippingElements = node.querySelectorAll ? node.querySelectorAll('.changeShipping') : [];
                        for (var j = 0; j < changeShippingElements.length; j++) {
                            changeShippingElements[j].addEventListener('click', function (e) {
                                e.preventDefault();
                                e.stopPropagation();
                                e.stopImmediatePropagation();
                                showCustomCountrySwitcher();
                                return false;
                            }, true);
                        }
                    }
                }
            }
        });
    });

    // Start observing the document body for added nodes
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
}());
